export default __webpack_public_path__ + "static/glex_cover-35d7377d925e2344f6767dd496011022.png";